export const getRandomizedInterval = (base: number): number => {
  const randomValue = Math.round(400 - 0.5 + Math.random() * (500 - 400 + 1));

  return base + (randomValue * base * 3) / 1000;
};
